import client from "../utils/client";

const fetchAllResults = async (user_id, contest_id) => {
  const url = `/api/results_full`;
  const response = await client().get(url, {
    params: {
      contest_id,
      user_id,
    },
  });
  return response;
};

const fetchKOResults = async (user_id, contest_id) => {
  const url = `/api/results_ko`;
  const response = await client().get(url, {
    params: {
      contest_id,
      user_id,
    },
  });
  return response;
};

const fetchLeaderboard = async (user_id, contest_id, limit = 100, offset = 0) => {
  const url = `/api/leaderboard`;
  const response = await client().get(url, {
    params: {
      contest_id,
      user_id,
      limit,
      offset,
    },
  });
  return response;
};

// Full knockout bracket skeleton (all matches incl. unresolved TBD slots) from
// knockout_stage_games. Contest-scoped only (no per-user fields); user picks
// come from results_ko/results_full. Response: { knockout_games: { <round>: [...] } }.
const fetchKnockoutGames = async (contest_id) => {
  const url = `/api/knockout_games`;
  const response = await client().get(url, {
    params: {
      contest_id,
    },
  });
  return response;
};

export {
  fetchAllResults,
  fetchKOResults,
  fetchLeaderboard,
  fetchKnockoutGames,
};
